import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BankDetails } from 'src/app/models/bank-details';
import { BankValidators } from 'src/app/validators/bank-validators';

@Component({
  selector: 'bank-iban-form',
  templateUrl: './bank-iban-form.component.html',
  styleUrls: ['./bank-iban-form.component.scss']
})
export class BankIbanFormComponent implements OnInit {
  @Output() confirm = new EventEmitter<BankDetails>();

  error: string = null;
  loading = false;

  form = this.fb.group({
    iban: ['', BankValidators.IBAN()],
    accountHolderLegalName: ['', BankValidators.accountHolder()],
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit() {}

  onSubmit() {
    if (this.form.valid) {
      this.confirm.emit(this.form.value);
    } else {
      this.error = 'Please fill out the required fields';
    }
  }
}
